import InfiniteCarousel, {
  InfiniteCarouselProps,
} from '@/features/carousel/components/infinite-carousel';
import PaginatedCarousel, {
  PaginatedCarouselProps,
} from '@/features/carousel/components/paginated-carousel';
import ScrollableCarousel, {
  ScrollableCarouselProps,
} from '@/features/carousel/components/scrollable-carousel';

import { CarouselVariant } from '../types';

type CarouselProps =
  | ScrollableCarouselProps
  | PaginatedCarouselProps
  | InfiniteCarouselProps;

export default function Carousel(props: CarouselProps) {
  if (props.variant === CarouselVariant.PAGINATED) {
    return <PaginatedCarousel {...props} />;
  }

  if (props.variant === CarouselVariant.INFINITE) {
    return <InfiniteCarousel {...props} />;
  }

  return <ScrollableCarousel {...props} />;
}
